
import { defineComponent } from 'vue';
import AdParams from './AdParams.vue';
import AdListItemPrice from './AdListItemPrice.vue';

import { mapGetters, mapState } from 'vuex';
import { GlobalState } from '@/shared/models/GlobalState';

export default defineComponent({
  props: {
    isPublic: Boolean,
    currentAdId: Number,
    ad: {
      type: Object,
      required: true,
    },
  },
  components: {
    AdParams,
    AdListItemPrice,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['isMobile']),
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
  },
  methods: {
    onPublishChanged() {
      this.$emit('publishChange', this.ad);
    },
  },
});
